import Svg from 'components/svg/svg'
import styles from './radio.module.scss'
import { cn } from 'utils/helpers'

export default function Radio({ className, options, readOnly, value, onChange, required, name }) {
    return (
        <div className={cn(styles.radios, readOnly && styles.readonly, className)}>
            <div className={styles.radiosWrap}>
                {options.map(option => (
                    <label key={option.value}>
                        <input
                            type="radio"
                            value={option.value}
                            required={required}
                            name={name}
                            checked={option.value === value}
                            onChange={onChange}
                            readOnly={readOnly}
                        />
                        <i>
                            <Svg name="circle" />
                        </i>
                        <span>{option.name}</span>
                    </label>
                ))}
            </div>
        </div>
    )
}
